import { CSSProperties, FC } from "react";
import { PromotionBannerProps } from "../PromotionBannerTypes";
import { Text, Heading } from "@otrium/atoms";
import styles from "../PromotionBanner.module.scss";
import { Timer } from "src/atoms/Timer";
import NoSSR from "src/atoms/NoSSR";
import { PromotionBannerImage } from "../PromotionBannerImage";
import { BREAKPOINTS } from "src/breakpoints";

interface BannerTimerProps extends PromotionBannerProps {
  startDate: string;
  endDate: string;
  backgroundColor: string;
  onTimerEnd?: (hasTimerEnded: boolean) => void;
  hideCTAButton?: boolean;
}

const BannerTimer: FC<BannerTimerProps> = ({
  images,
  description,
  buttonTitle,
  buttonColor,
  buttonTextColor,
  conditionText,
  endDate,
  backgroundColor,
  onTimerEnd,
  hideCTAButton,
  titleColor,
  textColor,
  priority,
}) => {
  return (
    <div className={styles.typeTwoWrapper}>
      <div
        className={styles.timerHeadingWrapper}
        style={{ "--banner-bg": backgroundColor } as CSSProperties}
      >
        <Heading
          as="h2"
          className={styles.timerHeading}
          variant="h1"
          color={titleColor || "tone.white"}
          pb={0}
          fontSize={[4, 4, 4, 5]}
          fontWeight="700"
          lineHeight={["40px", "40px", "40px", "64px"]}
        >
          <NoSSR>
            <Timer endDate={endDate} onTimerEnd={onTimerEnd} />
          </NoSSR>
        </Heading>

        {description && (
          <Text
            as="p"
            fontSize={["fontSize18", "fontSize18"]}
            lineHeight={["24px", "24px", "32px"]}
            textAlign="center"
            color={textColor || "tone.white"}
            mb="space16"
          >
            {description}
          </Text>
        )}
        {!hideCTAButton ? (
          <div
            className={styles.fakeButton}
            style={
              {
                "--banner-button-color": buttonTextColor,
                "--banner-button-bg": buttonColor,
              } as CSSProperties
            }
          >
            {buttonTitle}
          </div>
        ) : null}
        {conditionText && (
          <Text
            fontSize={0}
            color={textColor || "tone.white"}
            textAlign="center"
          >
            {conditionText}
          </Text>
        )}
      </div>
      <div className={styles.timerImgWrapper}>
        <PromotionBannerImage
          images={images}
          className={styles.timerPicture}
          sizes={`(max-width: ${BREAKPOINTS.sm}) 100vw, calc(50vw + 32px)`}
          priority={priority}
        />
      </div>
    </div>
  );
};

export { BannerTimer };
